import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ao3Faqs } from "@/mocks/ao3Home";
import Ao3Reveal from "./Ao3Reveal";

export default function Ao3Faq() {
  const { t } = useTranslation();
  const [openId, setOpenId] = useState<string | null>(ao3Faqs[0]);

  return (
    <section id="ao3-faq" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-3xl px-4 md:px-6">
        <Ao3Reveal className="text-center">
          <span className="text-xs font-semibold tracking-[0.2em] text-primary-700 dark:text-primary-400">{t("faq.badge")}</span>
          <h2 className="mt-3 font-heading text-2xl font-semibold text-foreground-950 md:text-4xl">{t("faq.title")}</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{t("faq.subtitle")}</p>
        </Ao3Reveal>

        <div className="mt-10 space-y-3">
          {ao3Faqs.map((id, index) => {
            const open = openId === id;
            return (
              <Ao3Reveal key={id} delay={index * 60}>
                <div className="overflow-hidden rounded-lg border border-background-200/70 bg-background-50">
                  <button
                    type="button"
                    onClick={() => setOpenId(open ? null : id)}
                    aria-expanded={open}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-4 text-left md:px-5"
                  >
                    <span className="text-sm font-semibold text-foreground-950 md:text-base">{t(`faq.items.${id}.q`)}</span>
                    <i className={`${open ? "ri-subtract-line" : "ri-add-line"} text-lg leading-none text-primary-600 dark:text-primary-400 shrink-0`} />
                  </button>
                  <div className={`grid transition-all duration-300 ease-out ${open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                    <div className="overflow-hidden">
                      <p className="px-4 pb-4 text-sm leading-relaxed text-foreground-600 md:px-5">{t(`faq.items.${id}.a`)}</p>
                    </div>
                  </div>
                </div>
              </Ao3Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}